import Thread from './thread';
import ThreadVM from './thread-vm';
export default {
  init: function() {
    var data            = $('#ko_forum_thread_view_model').attr('data-json');
    var thread_model    = new ThreadVM(data);
    // ko.mapping.fromJSON(data, thread_model.mappingOptions, thread_model); // used to be fromJS
    var el = $('#ko_forum_thread_view_model')[0];

    var validationOptions = _.extend({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, {
      messageTemplate: 'comment-error-tmpl'
    });

    if (el) {
      ko.applyBindingsWithValidation(thread_model, el, validationOptions);

      $(el).data('VM', thread_model); // Save access to VM globally

      if (Thread.getCommentTarget()) // scroll to comment specified in url if there is one
        Thread.scrollToElement(Thread.getCommentTarget());

    }

    Kadenze.IframeUtils.decorateAll();
  }
};
